import { PropsWithChildren } from 'react';
import { Card } from '@mokoboko/components';

import { PageContainer } from './page-container';
import { PoweredByTimitomi } from './powered-by-timitomi';

export const OfferingListFrame = ({ children }: PropsWithChildren) => (
  <div>
    <PageContainer>
      <Card
        className="max-sm:rounded-none"
        contentClassName="p-5 flex flex-col gap-4 sm:gap-5"
      >
        {children}
      </Card>
    </PageContainer>
    <PoweredByTimitomi />
  </div>
);
